/* Copyright © Bankers Healthcare Group, Inc.  All rights reserved. */

import Vue from 'vue';
import Vuex from 'vuex';
import FeatureFlagModule from './modules/FeatureFlagModule';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    FeatureFlagModule,
  },
});

const init = async () => {
  await store.dispatch('getFeatureFlags');
};

init();

export default store;
